var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "./BasicViewControllerWithCRUDDataSource", "../Models/User", "../Models/Room", "../Models/Location"], function (require, exports, BasicViewControllerWithCRUDDataSource_1, User_1, Room_1, Location_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var UserController = (function (_super) {
        __extends(UserController, _super);
        function UserController(options_) {
            var _this = this;
            var rolesAvailableGetUrl = options_.rolesAvailableGetUrl && options_.rolesAvailableGetUrl !== ""
                ? options_.rolesAvailableGetUrl
                : "/api/v1/users/roles";
            var vueAdditions = {
                data: {
                    rolesAvailable_: [],
                    search_text: "",
                    tenantsLocationsRoomsHierarchized: []
                },
                computed: {
                    rolesAvailable: {
                        get: function () {
                            var _this = this;
                            if (this.rolesAvailable_.length === 0) {
                                jQuery.get(rolesAvailableGetUrl).then(function (response) {
                                    _this.rolesAvailable_ = response;
                                }, function (response) {
                                    new Noty({
                                        text: "Rolen konnten leider nicht abgefragt werden",
                                        type: 'error',
                                        theme: 'metroui',
                                        timeout: 6000
                                    }).show();
                                });
                            }
                            return this.rolesAvailable_;
                        }
                    },
                    securityInfo: function () {
                        return _this.vueRoot.model.SecurityInfo;
                    },
                    tenantsVisible: {
                        get: function () {
                            return this.search_text && this.tenantsLocationsRoomsHierarchized ? window.Enumerable.from(this.tenantsLocationsRoomsHierarchized)
                                .select(function (item) {
                                return item;
                            })
                                .where(function (item) {
                                return item.visible;
                            })
                                .toArray() : [];
                        }
                    }
                },
                watch: {
                    search_text: function (newValue, oldValue) {
                        _this.vueRoot.filtere_tenants();
                    }
                },
                methods: {
                    getVisibleTenants: function () {
                        return _this.vueRoot !== undefined && _this.vueRoot.search_text !== undefined && _this.vueRoot.tenantsLocationsRoomsHierarchized !== undefined ? window.Enumerable.from(_this.vueRoot.tenantsLocationsRoomsHierarchized)
                            .select(function (item) {
                            return item;
                        })
                            .where(function (item) {
                            return item.visible;
                        })
                            .toArray() : [];
                    },
                    getLocationsOfTetant: function (tenant) {
                        return window.Enumerable.from(_this.vueRoot.locations)
                            .where(function (item) { return item.TenantId = tenant.Id; })
                            .select(function (item) { return item; }).toArray();
                    },
                    getRoomsOfLocation: function (location) {
                        return window.Enumerable.from(_this.vueRoot.rooms)
                            .where(function (item) { return item.LocationId = location.Id; })
                            .select(function (item) { return item; }).toArray();
                    },
                    filtere_tenants: function (filter) {
                        var keep_empty = _this.vueRoot.search_text === "";
                        _this.vueRoot.tenantsLocationsRoomsHierarchized.forEach(function (tenant) {
                            var visibleLocations = 0;
                            tenant._locations.forEach(function (location) {
                                var visibleRooms = 0;
                                location._rooms.forEach(function (room) {
                                    room.visible = room.Name.toLowerCase().includes(_this.vueRoot.search_text.toLowerCase());
                                    if (room.visible)
                                        visibleRooms++;
                                });
                                location.visible = visibleRooms > 0 || keep_empty || location.CompanyName.toLowerCase().includes(_this.vueRoot.search_text.toLowerCase());
                                if (location.visible)
                                    visibleLocations++;
                            });
                            tenant.visible = visibleLocations > 0 || keep_empty || tenant.CompanyName.toLowerCase().includes(_this.vueRoot.search_text.toLowerCase());
                        });
                    }
                }
            };
            _this = _super.call(this, options_, vueAdditions) || this;
            _this.defaultRight = 15;
            _this.AddEventListener(_this.events.tenantsLoaded, function (s, d) { return _this.CheckDataAndProccedWithRendering(s, d); });
            _this.AddEventListener(_this.events.locationsLoaded, function (s, d) { return _this.CheckDataAndProccedWithRendering(s, d); });
            _this.AddEventListener(_this.events.roomsLoaded, function (s, d) { return _this.CheckDataAndProccedWithRendering(s, d); });
            return _this;
        }
        UserController.prototype.CheckDataAndProccedWithRendering = function (sender, responce) {
            var _this = this;
            if (this.vueRoot.tenants.length === 0 || this.vueRoot.locations.length === 0 || this.vueRoot.rooms.length === 0)
                return;
            var tenants = window.Enumerable.from(this.vueRoot.tenants)
                .orderByDescending(function (item) { return item.CompanyName; })
                .select(function (item) {
                return _this.AddAllRuleHelperProperties(_this.AddTreeHelperProperiesTo(item, "tenantAssignment", null));
            })
                .toArray();
            var _loop_1 = function () {
                var _a;
                var tenantId = tenants[i].Id;
                var allLocationsElement = new Location_1.Location();
                allLocationsElement.Id = "all";
                allLocationsElement.CompanyName = "Alle Bereiche, inkl. aller Räume";
                allLocationsElement.Tenant = tenants[i];
                allLocationsElement.TenantId = tenantId;
                tenants[i]["_locations"] = [];
                tenants[i]["_locations"].push(this_1.AddAllRuleHelperProperties(this_1.AddTreeHelperProperiesTo(allLocationsElement, "locationAssignment", tenants[i])));
                (_a = tenants[i]["_locations"]).push.apply(_a, window.Enumerable.from(this_1.vueRoot.locations)
                    .where(function (item) { return item.TenantId == tenantId; })
                    .orderByDescending(function (item) { return item.CompanyName; })
                    .select(function (item) {
                    item.Tenant = tenants[i];
                    return _this.AddAllRuleHelperProperties(_this.AddTreeHelperProperiesTo(item, "locationAssignment", tenants[i]));
                })
                    .toArray());
                var _loop_2 = function (i2) {
                    var _a;
                    var locationId = tenants[i]["_locations"][i2].Id;
                    var allRoomsElement = new Room_1.Room();
                    allRoomsElement.Id = "all";
                    allRoomsElement.Name = "Alle Räume";
                    allRoomsElement.Location = tenants[i]["_locations"][i2];
                    allRoomsElement.LocationId = locationId;
                    tenants[i]["_locations"][i2]["_rooms"] = [];
                    tenants[i]["_locations"][i2]["_rooms"].push(this_1.AddTreeHelperProperiesTo(allRoomsElement, "roomAssignment", tenants[i]["_locations"][i2]));
                    (_a = tenants[i]["_locations"][i2]["_rooms"]).push.apply(_a, window.Enumerable.from(this_1.vueRoot.rooms)
                        .where(function (item) { return item.LocationId == locationId; })
                        .orderByDescending(function (item) { return item.Name; })
                        .select(function (item) {
                        item.Location = tenants[i]["_locations"][i2];
                        return _this.AddTreeHelperProperiesTo(item, "roomAssignment", tenants[i]["_locations"][i2]);
                    })
                        .toArray());
                };
                for (var i2 in tenants[i]["_locations"]) {
                    _loop_2(i2);
                }
            };
            var this_1 = this;
            for (var i in tenants) {
                _loop_1();
            }
            this.vueRoot.tenantsLocationsRoomsHierarchized = tenants;
        };
        UserController.prototype.SetSecurityInfo = function (source) {
            if (source.selected) {
                this.AddAccessRightToModelAndSelectParentRecursively(source);
                if (source.type === "locationAssignment" && source.Id === "all" && source.allRuleElement !== null) {
                    source.allRuleElement.selected = true;
                    this.DeselectAllChildrenButAll(source.parent);
                }
                else if (source.type === "roomAssignment" && source.Id === "all") {
                    this.DeselectAllChildrenButAll(source.parent);
                }
                else if ((source.type === "roomAssignment" || source.type === "locationAssignment") && source.Id !== "all" && source.parent.allRuleElement !== null) {
                    source.parent.allRuleElement.selected = false;
                }
            }
            else {
                this.DeleteAccessRightFromModelAndDeselectChildren(source);
                this.DeselectParentNodeIfAllChildrenDeselted(source.parent);
            }
            this.vueRoot.$forceUpdate();
        };
        UserController.prototype.DeselectAllChildrenButAll = function (parent) {
            this.GetAllChildrenBySelectValue(parent, true).forEach(function (child) {
                if (child.Id !== "all") {
                    child.selected = false;
                }
            });
        };
        UserController.prototype.DeselectParentNodeIfAllChildrenDeselted = function (parent) {
            if (parent === null)
                return;
            if (this.GetAllChildrenBySelectValue(parent, true).length < 1)
                parent.selected = false;
        };
        UserController.prototype.GetAllChildrenBySelectValue = function (parent, selected) {
            return window.Enumerable.from(parent.children).where(function (item) { return item.selected === selected; }).toArray();
        };
        UserController.prototype.GetAllChildrenById = function (parent, id) {
            return window.Enumerable.from(parent.children).where(function (item) { return item.Id === id; }).toArray();
        };
        UserController.prototype.IsSelectedInModel = function (source, type) {
            return this.GetAccessRightFromModel(source, type) !== null;
        };
        UserController.prototype.GetAccessRightFromModel = function (source, type) {
            var sourceId = source.Id;
            var modelSecurityInfo = this.vueRoot.model.SecurityInfo;
            if (modelSecurityInfo.Assignment.length === 0)
                return null;
            function filter(id, filterSource) {
                var result = window.Enumerable.from(filterSource)
                    .where(function (item) {
                    try {
                        return UserController.ObjectsHaveSameKeys(new User_1.RoomAssignment("", 0), item)
                            ? item.Id === id
                            : item.AccessRight.Id === id;
                    }
                    catch (e) {
                        return false;
                    }
                })
                    .select(function (item) {
                    return item;
                })
                    .toArray();
                return result.length > 0 ? result[0] : null;
            }
            switch (type) {
                case 'tenantAssignment':
                    return filter(sourceId, modelSecurityInfo.Assignment);
                    break;
                case 'locationAssignment':
                    for (var i in modelSecurityInfo.Assignment) {
                        if (modelSecurityInfo.Assignment[i].AccessRight.Id === source.parent.Id)
                            return filter(sourceId, modelSecurityInfo.Assignment[i].Locations);
                    }
                    break;
                case 'roomAssignment':
                    for (var i in modelSecurityInfo.Assignment) {
                        if (source.parent.parent.Id === modelSecurityInfo.Assignment[i].AccessRight.Id)
                            for (var i2 in modelSecurityInfo.Assignment[i].Locations) {
                                if (source.parent.Id === modelSecurityInfo.Assignment[i].Locations[i2].AccessRight.Id)
                                    return filter(sourceId, modelSecurityInfo.Assignment[i].Locations[i2].Rooms);
                            }
                    }
                    break;
            }
            return null;
        };
        UserController.prototype.AddAccessRightToModelAndSelectParentRecursively = function (source) {
            var modelSecurityInfo = this.vueRoot.model.SecurityInfo;
            var accessRight = this.GetAccessRightFromModel(source, source.type);
            if (accessRight !== null) {
                console.log("usercontroller->AddAccessRightToModel: accessright not added to model, it allready existst");
                return;
            }
            switch (source.type) {
                case 'tenantAssignment':
                    var TA = new User_1.TenantAssignment(source.Id, this.defaultRight);
                    modelSecurityInfo.Assignment.push(TA);
                    return TA;
                    break;
                case 'locationAssignment':
                    var TA = this.GetAccessRightFromModel(source.Tenant, "tenantAssignment");
                    if (TA === null)
                        TA = this.AddAccessRightToModelAndSelectParentRecursively(source.Tenant);
                    var LA = new User_1.LocationAssignment(source.Id, this.defaultRight);
                    TA.Locations.push(LA);
                    if (!source.Tenant.selected)
                        source.Tenant.selected_ = true;
                    return LA;
                    break;
                case 'roomAssignment':
                    var LA = this.GetAccessRightFromModel(source.Location, "locationAssignment");
                    if (LA === null)
                        LA = this.AddAccessRightToModelAndSelectParentRecursively(source.Location);
                    var RA = new User_1.RoomAssignment(source.Id, this.defaultRight);
                    LA.Rooms.push(RA);
                    if (!source.Location.selected)
                        source.Location.selected_ = true;
                    return RA;
                    break;
            }
        };
        UserController.prototype.DeleteAccessRightFromModelAndDeselectChildren = function (source) {
            var _this = this;
            var modelSecurityInfo = this.vueRoot.model.SecurityInfo;
            var accessRight = this.GetAccessRightFromModel(source, source.type);
            if (accessRight === null)
                return;
            switch (source.type) {
                case 'tenantAssignment':
                    var indexT = modelSecurityInfo.Assignment.indexOf(accessRight);
                    if (indexT === -1) {
                        console.log("UserController -> DeleteAccessRightFromModelAndDeselectChildren -> switch -> tenantAssignment: index out of range -> return");
                        return;
                    }
                    modelSecurityInfo.Assignment.splice(indexT, 1);
                    this.GetAllChildrenBySelectValue(source, true).forEach(function (location) {
                        location.selected_ = false;
                        _this.GetAllChildrenBySelectValue(location, true).forEach(function (room) {
                            room.selected_ = false;
                        });
                    });
                    break;
                case 'locationAssignment':
                    var tenantAssignment_1;
                    modelSecurityInfo.Assignment.forEach(function (tenantAssignment_) {
                        if (source.TenantId === tenantAssignment_.AccessRight.Id) {
                            tenantAssignment_1 = tenantAssignment_;
                        }
                    });
                    var indexL = tenantAssignment_1.Locations.indexOf(accessRight);
                    if (indexL === -1) {
                        console.log("UserController -> DeleteAccessRightFromModelAndDeselectChildren -> switch -> locationAssignment: index out of range -> return");
                        return;
                    }
                    tenantAssignment_1.Locations.splice(indexL, 1);
                    this.GetAllChildrenBySelectValue(source, true).forEach(function (room) {
                        room.selected_ = false;
                    });
                    break;
                case 'roomAssignment':
                    var locationAssignment_1;
                    modelSecurityInfo.Assignment.forEach(function (tenantAssignment_) {
                        tenantAssignment_.Locations.forEach(function (locationAssignment_) {
                            if (source.LocationId === locationAssignment_.AccessRight.Id) {
                                locationAssignment_1 = locationAssignment_;
                            }
                        });
                    });
                    var indexR = locationAssignment_1.Rooms.indexOf(accessRight);
                    if (indexR === -1) {
                        console.log("UserController -> DeleteAccessRightFromModelAndDeselectChildren -> switch -> roomAssignment: index out of range -> return");
                        return;
                    }
                    locationAssignment_1.Rooms.splice(indexR, 1);
                    break;
            }
        };
        UserController.prototype.AddAllRuleHelperProperties = function (element) {
            Object.defineProperties(element, {
                'allRuleElement': {
                    get: function () {
                        for (var i in this.children)
                            if (this.children[i].Id === "all")
                                return this.children[i];
                        return null;
                    },
                    enumerable: true
                },
                'isAllRuleElementSelected': {
                    get: function () {
                        var allRuleElement = this.allRuleElement;
                        return allRuleElement !== null && allRuleElement.selected === true;
                    },
                    enumerable: true
                }
            });
            return element;
        };
        UserController.prototype.AddTreeHelperProperiesTo = function (item, type, parent) {
            var base = this;
            Object.defineProperties(item, {
                'selected_': {
                    value: false,
                    writable: true
                },
                'selected': {
                    get: function () {
                        return this.selected_;
                    },
                    set: function (value) {
                        this.selected_ = value;
                        base.SetSecurityInfo(this);
                    },
                    enumerable: true
                },
                'visible_': {
                    value: true,
                    writable: true
                },
                'visible': {
                    get: function () {
                        return this.visible_;
                    },
                    set: function (value) {
                        this.visible_ = value;
                    },
                    enumerable: true
                },
                'type': {
                    value: type,
                    enumerable: true
                },
                'parent': {
                    get: function () {
                        switch (this.type) {
                            case 'tenantAssignment':
                                return null;
                                break;
                            case 'locationAssignment':
                                return this.Tenant;
                                break;
                            case 'roomAssignment':
                                return this.Location;
                                break;
                        }
                    },
                    enumerable: true
                },
                'children': {
                    get: function () {
                        switch (this.type) {
                            case 'tenantAssignment':
                                return this._locations;
                                break;
                            case 'locationAssignment':
                                return this._rooms;
                                break;
                            case 'roomAssignment':
                                return [];
                                break;
                        }
                    },
                    enumerable: true
                }
            });
            if (type === "tenantAssignment")
                Object.defineProperties(item, {
                    'isLocationsSelectionInvalid': {
                        get: function () {
                            return this.selected && base.GetAllChildrenBySelectValue(this, true).length < 1;
                        },
                        enumerable: true
                    },
                    'isR': {
                        get: function () {
                            return this.selected && base.GetAllChildrenBySelectValue(this, true).length < 1;
                        },
                        enumerable: true
                    }
                });
            item.selected_ = this.IsSelectedInModel(item, type);
            return item;
        };
        UserController.ObjectsHaveSameKeys = function () {
            var objects = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                objects[_i] = arguments[_i];
            }
            var allKeys = objects.reduce(function (keys, object) { return keys.concat(Object.keys(object)); }, []);
            var union = new Set(allKeys);
            return objects.every(function (object) { return union.size === Object.keys(object).length; });
        };
        return UserController;
    }(BasicViewControllerWithCRUDDataSource_1.BasicViewControllerWithCRUDDataSource));
    exports.UserController = UserController;
    $(function () {
        var optionsList = window["userControllerData"];
        for (var i in optionsList) {
            window["userController" + i] = new UserController(optionsList[i]);
        }
    });
});
//# sourceMappingURL=UserController.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/UserController.js
// module id = 404
// module chunks = 0